import { Controller } from '../utils/controller';
import { LiveChatInit } from '../../vendor/livechat-init.min';

export default class extends Controller {
  static values = {
    businessUnitId: {
      type: String,
      default: ''
    },
    environment: {
      type: String,
      default: ''
    },
    languageCode: {
      type: String,
      default: ''
    }
  };

  declare businessUnitIdValue: string;
  declare environmentValue: string;
  declare languageCodeValue: string;

  private async init(): Promise<void> {
    const businessUnitId = this.businessUnitIdValue;
    const environment = this.environmentValue;
    const languageCode = this.languageCodeValue;

    if (businessUnitId && environment) {
      await LiveChatInit.init({ businessUnitId, languageCode, environment });
    }
  }

  connect(): void {
    this.init();
  }
}
